import { IInitializationService } from "./types";
import { observable, runInAction } from "mobx";
import LocaleProvider from "../localeProvider";
import LocalizationService from "../localizationService";
import ValidationService from "../validationService";
import AuthorizationService from "../authorizationService";
import OutageService from "../outageService";
import { validatorsRepository } from "@frui.ts/validation";
import { availableLocales } from "../../config";

export default class InitializationWithOutagesService implements IInitializationService {
  @observable isInitialized: boolean;

  constructor(
    private localeProvider: LocaleProvider,
    private localizationService: LocalizationService,
    private validationService: ValidationService,
    private authorizationService: AuthorizationService,
    private outageService: OutageService
  ) {
    this.isInitialized = false;
  }

  async initialize(defaultLanguage?: string) {
    this.validationService.initialize(validatorsRepository as any);
    this.localeProvider.initialize(availableLocales, defaultLanguage);
    this.authorizationService.initialize();
    this.outageService.initialize();

    await Promise.all([this.localizationService.initialize()]);

    runInAction(() => (this.isInitialized = true));
  }
}
